<template>
  <section pricing-table :data-theme="blok.style || 'default'">
    <div class="container">
      <div class="row">
        <div class="section-menu">
          <select v-model="country" @change="onCountryChange">
            <option disabled selected :value="null">Select your destination</option>
            <option v-for="region in blok.regions" :key="blok._uid" v-text="region.country"></option>
          </select>
        </div>
        <StoryblokComponent v-for="blok in selectedRegionBlok" :key="blok._uid" :blok="blok" />
      </div>
      <div class="row section-buttons flex justify-center">
        <StoryblokComponent v-for="blok in blok.buttons" :key="blok._uid" :blok="blok" />
      </div>
    </div>
  </section>
</template>
<style src="~/assets/scss/section/pricing-table.scss" lang="scss"></style>
<script setup>
const route = useRoute();
const router = useRouter();

const props = defineProps({ blok: Object });
const country = ref("Australia");
const regions = reactive(props.blok.regions);
const selectedRegionBlok = computed(() => {
  return regions.filter((r) => r.country === country.value);
});

const onCountryChange = () => {
  // Update URL Parameter
  router.push({ query: { ...route.query, country: country.value } });
};

onBeforeMount(() => {
  // Check if country parameter exist
  const countryParam = route.query.country;
  if (countryParam && regions.map((r) => r.country).includes(countryParam)) {
    // Update the model to select the country
    country.value = countryParam;
  } else if (regions.length > 0) {
    // Pre-select first country on the list
    country.value = regions[0].country;
  }
});
</script>
